(function(w) {
  function initOkendo() {
    if (!w.okeWidgetApi) return;
    var el = document.querySelector('[data-oke-reviews-widget]');
    if (el) w.okeWidgetApi.initWidget(el);
  }
  function scheduleInit() {
    if ('requestIdleCallback' in w) {w.requestIdleCallback(initOkendo, { timeout: 3000 });} else {initOkendo();}
  }
  if (document.readyState === 'complete') {scheduleInit();} else {w.addEventListener('load', scheduleInit, { once: true });}
})(window);
